export const DOCUMENT_TYPE_DOOR_CONTENT = 'doorContent';
export const DOOR_CONFIGURATOR_PATH = '/konfigurator/balkongdor';
